import { Route } from '@angular/router';
import { authGuard } from '@umss/shared/core';

export const appRoutes: Route[] = [
  // Load shell routes (includes FacilityLayoutComponent with side-nav + all feature routes)
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@umss/facility/feature-shell').then((m) => m.shellRoutes)
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('@umss/facility/feature-auth').then((m) => m.routes)
  },

  // Fallback - redirect to root (which will redirect to dashboard via shell routes)
  { path: '**', redirectTo: '' }
];
